
export const convertDate = (timestamp, showhours) => {
    const date = new Date(timestamp);

    // Obter data no formato xx/xx/xxxx
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    // Formatar a data
    let formattedDate = `${day}/${month}/${year}`;

    // Se showhours for true, adicionar a hora no formato xx:xx
    if (showhours) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        formattedDate += ` às ${hours}:${minutes}:${seconds}`;
    }

    return formattedDate;
};


export const convertDateTmdb = (date) => {

    
    const mesesPT = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    const dataObj = new Date(date);
    const mes = dataObj.getMonth();
    return `${dataObj.getDate() + 1} de ${mesesPT[mes]} de ${dataObj.getFullYear()}`;
};

